export function ModeIcon({ children }) {
  return (
    <span className="w-fit h-8 [&_svg]:h-8 [&_svg]:w-auto [&_svg]:fill-current [&_svg]:stroke-current">
      {children}
    </span>
  );
}
